'use client';

import Image from 'next/image';
import { FC } from 'react';

import { AWARDS_IMAGES } from '@/components/Awards/assets';
import { CaseStudyAwardDto } from '@/types/case-studies';

import css from './style.module.scss';

interface Props {
	award: CaseStudyAwardDto;
}

const AwardItem: FC<Props> = ({ award }) => {
	const text = `${award.shortName}, ${award.year}`;
	const src = AWARDS_IMAGES[award.type];

	if (!src) return null;

	return (
		<div className={css.award}>
			{text}
			<Image width={28} height={37} alt="" src={src} className={css.icon} />
		</div>
	);
};

export default AwardItem;
